<script setup lang="ts">
import SparklineValuesDTO = Modules.BookingExperts.Data.SparklineValuesDTO;
import { onBeforeMount, ref, watch } from "vue";
import { useApiClient } from "@/api/client";
import { formatNumber } from "chartjs-graph";
import { useHomeStore } from "@/modules/home/store";

const store = useHomeStore();

const sparklineLabelValues = ref<SparklineValuesDTO | undefined>();

watch(() => store.daysToLookBack, getSparklineValues);
onBeforeMount(getSparklineValues);

async function getSparklineValues() {
	const labelResponse = await useApiClient("proLoyalty").getSparklineValues(
		"label",
		{ daysToLookBack: store.daysToLookBack }
	);
	if (labelResponse.isOk()) {
		sparklineLabelValues.value = labelResponse.value;
	}
}
</script>

<template>
	<v-card class="home-graph-card">
		<v-card-title class="bg-background" style="height: 48px">
			Labels
		</v-card-title>
		<div
			v-if="sparklineLabelValues"
			class="d-flex flex-column justify-space-between"
		>
			<div class="pa-3">
				<div class="d-flex align-center">
					<v-chip
						variant="tonal"
						color="rgba(251, 192, 45)"
						size="large"
						style="font-size: 28px; font-weight: 500"
					>
						{{ formatNumber(sparklineLabelValues?.sum) }}
					</v-chip>
					<span class="ml-2">Created in Bex</span>
					<v-spacer />
					<v-avatar
						color="rgba(251, 192, 45)"
						variant="tonal"
						class="rounded-md"
					>
						<v-icon size="24">fa: fa-light fa-tags</v-icon>
					</v-avatar>
				</div>
			</div>
			<v-sparkline
				v-if="sparklineLabelValues"
				:model-value="sparklineLabelValues.values"
				:gradient="['rgba(251, 192, 45, 0.05)', 'rgba(251, 192, 45, 0.2)']"
				color="#FBC02D"
				height="100"
				stroke-linecap="round"
				line-width="2"
				fill
				smooth
				type="trend"
				:show-labels="false"
				padding="0"
			>
			</v-sparkline>
		</div>
	</v-card>
</template>

<style scoped lang="scss">
.home-graph-card {
	display: grid;
	grid-template-rows: auto 1fr;
}
</style>
